<template>
  <div class="m-4 mx-auto my-6 flex max-w-xl flex-col rounded-lg bg-white p-4">
    <h1 class="text-lg font-normal">
      Tell us what you need help with. Please type and select the roles, skills
      or tools that you need help with. The more the better!
    </h1>

    <KeywordSearch :error="error" />
    <word-selector :title="`Your Requirements`"> </word-selector>
  </div>
</template>

<script>
import KeywordSearch from '@/components/serviceSelection/KeywordSearch.vue';
import WordSelector from '@/components/serviceSelection/WordSelector.vue';
import { mapStores } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';

export default {
  name: 'RequirementSelector',
  components: {
    KeywordSearch,
    WordSelector,
  },
  props: {
    error: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapStores(useCheckoutStore),
  },
  created() {
    this.checkoutStore.initialSetup();
  },
};
</script>
